import { render, staticRenderFns } from "./index.vue?vue&type=template&id=17eb965a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=17eb965a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17eb965a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17eb965a')) {
      api.createRecord('17eb965a', component.options)
    } else {
      api.reload('17eb965a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=17eb965a&scoped=true&", function () {
      api.rerender('17eb965a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goodsPreSaleConfig/index.vue"
export default component.exports